<template>
    <div>
      <div style="margin: 10px 0">
        <el-input style="width: 200px;" type="text" v-model="name" placeholder="请输入大棚名称" suffix-icon="el-icon-search"></el-input>
        <!-- 超级管理员可以选择公司筛选 -->
        <el-select v-if="user.role === '超级管理员'" v-model="companyId" clearable placeholder="请选择公司" style="width: 200px; margin-left: 10px;">
          <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id"></el-option>
        </el-select>
        <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button>

        <el-button style="float:right; margin-left: 10px" type="danger" @click = "deleteBatch">批量删除<i class="el-icon-remove-outline"></i></el-button>
        <el-button style="float:right;" type="primary" @click = "handAdd" icon="el-icon-circle-plus-outline">新增</el-button>
      </div>
      <!-- eslint-disable-next-line -->
      <el-table :data="tableData" border stripe :header-cell-class-name="headerBg" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="id" label="ID" width="100">
        </el-table-column>
        <el-table-column prop="name" label="大棚名称" width="140">
        </el-table-column>
        <el-table-column prop="fishVar" label="种植品种">
        </el-table-column>
        <el-table-column prop="companyid" label="公司">
          <template slot-scope="scope">
            {{ getCompanyName(scope.row.companyid) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime ? new Date(scope.row.createTime).toLocaleString() : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.updateTime ? new Date(scope.row.updateTime).toLocaleString() : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <!-- scope 拿到数据-->
            <el-button type="success" @click = "handEdit(scope.row)" style="margin-right: 5px">编辑<i class="el-icon-edit"></i></el-button>
            <el-popover
            placement="top"
            width="160"
            trigger="click">
            <p>您确定要删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible=false">取消</el-button>
              <el-button type="primary" size="mini" @click=handdele(scope.row.id)>确定</el-button>
            </div>
              <el-button type="danger" slot="reference">删除</el-button>
            </el-popover>

          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-dialog title="大棚信息" :visible.sync="dialogFormVisible" width="40%" >
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="大棚名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="种植品种">
            <el-input v-model="form.fishVar"></el-input>
          </el-form-item>
          <el-form-item label="所属公司">
            <!-- 超级管理员可以选择任何公司 -->
            <el-select v-if="user.role === '超级管理员'" v-model="form.companyid" placeholder="请选择公司">
              <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id"></el-option>
            </el-select>
            <!-- 普通管理员只能看到自己的公司且不可修改 -->
            <el-input v-else :value="getCompanyName(user.companyid)" readonly placeholder="所属公司"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save">确定</el-button>
            <el-button @click ='shutDown'>取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    </template>

    <script>
    export default {
      name: "Greenhouse",
      data () {
        return{
          tableData: [],
          name: '',
          companyId: null, // 用于筛选的公司ID
          pageNum: 1,
          pageSize: 10,
          total: 0,
          dialogFormVisible: false,
          form: {},
          multipleSelection: {},
          headerBg: 'headerBg',
          data: {},
          visible: true,
          user: localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{},
          companies: [],
          comid: null,
          options1:[]
        }
      },
      mounted () {
        // 先获取公司数据，再加载大棚数据
        this.getcompanies().then(() => {
          this.load()
        })
      },
      methods: {
        load () {//点击页码进行get请求
          this.request.get('/api/greenhouses/page', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              name: this.name,
              companyId: this.companyId
            }
          }).then(res => {
            console.log('API响应:', res)
            if (res && res.data) {
              this.tableData = res.data.records || []
              this.total = res.data.total || 0
              console.log('设置tableData:', this.tableData)
              console.log('设置total:', this.total)
            } else {
              console.log('响应数据结构不正确')
              this.tableData = []
              this.total = 0
            }
          }).catch(error => {
            console.error('API调用失败:', error)
            this.tableData = []
            this.total = 0
          })
        },
        save () { // 新增或更新
          this.request.post('/api/greenhouses/', this.form).then(res => {
            if (res && res.code === "200") {
              this.$message.success('保存成功')
              this.dialogFormVisible = false
              this.load()
            } else {
              this.$message.error('保存失败')
            }
          }).catch(error => {
            console.error('保存出错:', error)
            this.$message.error('保存失败，请重试')
          })
        },
        getcompanies () {
          // 超级管理员获取所有公司，普通管理员只获取自己的公司
          if (this.user.role === '超级管理员') {
            return this.request.get('/api/companies/').then(res => {
              if(res.code === "200"){
                this.companies = res.data.map(item => {
                  return {
                    id: item.id,
                    name: item.name
                  }
                })
                console.log('加载公司数据:', this.companies)
              }else{
                console.log('获取公司数据失败:', res.code, res.data);
                this.companies = []
              }
            }).catch(error => {
              console.error('获取公司数据出错:', error)
              this.companies = []
            })
          } else {
            // 普通管理员只获取自己的公司信息
            // 这里需要先获取公司名称，可能需要调用API
            return this.request.get('/api/companies/').then(res => {
              if(res.code === "200"){
                const userCompany = res.data.find(c => c.id === this.user.companyid)
                this.companies = [{
                  id: this.user.companyid,
                  name: userCompany ? userCompany.name : '未知公司'
                }]
                console.log('普通管理员的公司数据:', this.companies)
              }else{
                console.log('获取公司数据失败:', res.code, res.data);
                this.companies = [{
                  id: this.user.companyid,
                  name: '未知公司'
                }]
              }
            }).catch(error => {
              console.error('获取公司数据出错:', error)
              this.companies = [{
                id: this.user.companyid,
                name: '未知公司'
              }]
            })
          }
        },
        handAdd () {
          this.dialogFormVisible = true //打开表单
          this.form = {}
          // 普通管理员自动设置公司ID
          if (this.user.role !== '超级管理员') {
            this.form.companyid = this.user.companyid
          }
        },
        handEdit (row) { //把row里的数据传给表单
          this.form = JSON.parse(JSON.stringify(row)) // 深拷贝
          this.dialogFormVisible = true
        },
        handdele (id) { //通过id删除
          this.request.delete('/api/greenhouses/' + id).then(res => {
            if (res && res.code === "200") {
              this.$message.success('删除成功')
              this.load()
            } else {
              this.$message.error('删除失败')
            }
          }).catch(error => {
            console.error('删除出错:', error)
            this.$message.error('删除失败，请重试')
          })
        },
        handleSelectionChange (val) {
          console.log(val)
          this.multipleSelection = val
        },
        deleteBatch () {
          // eslint-disable-next-line
          let ids = this.multipleSelection.map(val => val.id)
          this.request.post('/api/greenhouses/del/batch', ids).then(res => {
            if (res && res.code === "200") {
              this.$message.success('批量删除成功')
              this.load()
            } else {
              this.$message.error('批量删除失败')
            }
          }).catch(error => {
            console.error('批量删除出错:', error)
            this.$message.error('批量删除失败，请重试')
          })
        },
        shutDown () {
          this.dialogFormVisible = false
        },
        handleSizeChange (pageSize) {
          this.pageSize = pageSize
          this.load()
        },
        handleCurrentChange (pageNum) {
          this.pageNum = pageNum
          this.load()
        },
        getCompanyName(companyId) {
          const company = this.companies.find(c => c.id === companyId)
          return company ? company.name : '未知公司'
        }
      }
    }
    </script>

    <style scoped>
    .headerBg {
      background: #f5f7fa;
    }
    </style>
